import {
  HANDOVERLIST_LOADING,
  GET_HANDOVERLIST,
  GET_HANDOVERLIST_SUCCESS,
  GET_HANDOVERLIST_FAIL,
  ADD_HANDOVERLIST_SUCCESS,
  ADD_HANDOVERLIST_FAIL,
  DELETE_HANDOVERLIST_SUCCESS,
  DELETE_HANDOVERLIST_FAIL,
  UPDATE_HANDOVERLIST_SUCCESS,
  UPDATE_HANDOVERLIST_FAIL,
  HANDOVERLIST_RESET
} from "./actionType";

const INIT_STATE = {
  handoverLists: [],
  error: {},
};

const HandoverList = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_HANDOVERLIST_SUCCESS:
      switch (action.payload.actionType) {
        case GET_HANDOVERLIST:
          return {
            ...state,
            handoverLists: action.payload.data,
            isHandoverListCreated: false,
            isHandoverListSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_HANDOVERLIST_FAIL:
      switch (action.payload.actionType) {
        case GET_HANDOVERLIST_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isHandoverListCreated: false,
            isHandoverListSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_HANDOVERLIST: {
      return {
        ...state,
        isHandoverListCreated: false,
        loading: true,
      };
    }

    case HANDOVERLIST_LOADING: {
      return {
        ...state,
        isHandoverListCreated: false,
        loading: true,
      };
    }

    case ADD_HANDOVERLIST_SUCCESS:
      return {
        ...state,
        isHandoverListCreated: true,
        loading: false,
        handoverLists: [action.payload.data, ...state.handoverLists],
      };

    case ADD_HANDOVERLIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_HANDOVERLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        handoverLists: state.handoverLists.filter(
          civilHandoverList => civilHandoverList.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_HANDOVERLIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_HANDOVERLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        handoverLists: state.handoverLists.map(civilHandoverList =>
          civilHandoverList.id.toString() === action.payload.data.id.toString() ? { ...civilHandoverList, ...action.payload.data } : civilHandoverList
        ),
      };

    case UPDATE_HANDOVERLIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case HANDOVERLIST_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default HandoverList;